import React from 'react';

import Loader from 'components/Loader';
import { insights as TEXT } from 'locales/en';
import { CURRENCY_SYMBOL } from 'utils/transform';
import { priceFromAPI } from 'utils/price';

const AverageDonation = ({ isLoading, data }) => {
  return (
    <div className="p-5 lg:p-7 h-28 relative">
      {isLoading ? (
        <Loader
          isBarVisible={false}
          fullScreen={false}
          className="pt-3 h-full justify-center"
        />
      ) : (
        <>
          <p className="mb-2 text-sm text-javelin-gray-dark text-opacity-40">
            {TEXT.donations.average}
          </p>
          <span className="font-bold min-w-28 w-auto text-sm">
            {data ? `${CURRENCY_SYMBOL.EUR}${priceFromAPI(data)}` : '-'}
          </span>
        </>
      )}
    </div>
  );
};

export default AverageDonation;
